import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgSelectModule} from '@ng-select/ng-select';
import {FormsModule} from '@angular/forms';

import {CoverArtRoutingModule} from './coverart-routing.module';
import {CoverArtComponent} from './coverart/coverart.component';
import {CoverArtListComponent} from './coverart-list/coverart-list.component';
import {CoverArtPageComponent} from './coverart-page/coverart-page.component';
import {SharedModule} from '../shared/shared.module';

@NgModule({
    declarations: [CoverArtComponent, CoverArtListComponent, CoverArtPageComponent],
    imports: [
        CommonModule,
        SharedModule,
        CoverArtRoutingModule,
        FormsModule,
        NgSelectModule
    ],
    exports: [
        CoverArtPageComponent
    ]
})
export class CoverArtModule {
}
